<template>
	<div class="form">
		<div v-if="hasHeader" class="form__header">
			<slot name="header" />
		</div>

		<div class="form__content">
			<slot />
		</div>

		<div v-if="hasFooter" class="form__footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { useHasSlot } from '@/composables';

export default defineComponent({
	setup(props, { slots }) {
		return {
			hasHeader: useHasSlot('header', slots),
			hasFooter: useHasSlot('footer', slots),
		};
	},
});
</script>

<style lang="scss">
.form {
	width: 100%;

	&__header {
		padding: 7rem 0 1rem;

		@include min-md {
			padding: 5rem 0 3rem;
		}
	}

	&__content {
		padding: 1.5rem 0;
	}
}
</style>
